import type { JourneyChronologyEntry } from '../guidance/journey/chronology'
import type { TaskActionMeta } from './TaskActionsSection'

export default function JourneyChronologyEntries({ entries, actions }: {
  entries: JourneyChronologyEntry[]
  actions: Pick<TaskActionMeta, 'id' | 'kind' | 'label' | 'seq'>[]
}) {
  return (
    <ol className="journey-chronology__entries">
      {entries.map((entry, index) => <li key={entry.seq} data-testid="chronology-entry">
        {entry.seq !== (entries[index - 1]?.seq ?? -1) + 1 && <p role="status">Some earlier chronology entries are unavailable.</p>}
        <div className="journey-chronology__meta">
          <span>{entry.step ? `Step ${entry.step}` : 'Before journey steps'}</span>
          <span>{entry.kind === 'history' ? (entry.substep ? 'Sub-action summary' : 'Step summary') : entry.kind}</span>
          {entry.recovery && <strong>Recovery</strong>}
          {entry.context && <span>{entry.context}</span>}
          <time dateTime={entry.timestamp}>{new Date(entry.timestamp).toLocaleTimeString()}</time>
        </div>
        <p>{entry.description}{entry.result ? ` → ${entry.result}` : ''}</p>
        {entry.url && <div className="journey-chronology__url">{entry.url}</div>}
        {entry.layout && <details><summary>Page changes</summary><pre>{entry.layout}</pre></details>}
        {entry.structure && <details><summary>Page observation text</summary><pre>{entry.structure}</pre></details>}
        <div className="journey-chronology__links">
          {entry.actionIds.map(id => {
            const action = actions.find(a => a.id === id)
            return action
              ? <a key={id} href={`#action-${id}`} title={action.label ?? action.kind} data-analytics-event="chronology-action-open">{action.kind} ({action.seq})</a>
              : <span key={id}>Action unavailable: {id}</span>
          })}
        </div>
      </li>)}
    </ol>
  )
}
